import React, { useState, useEffect } from 'react'
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from '../../helpers/interceptorServices';
import { apiList } from '../../helpers/apiList';
import CustomAlert from '../../helpers/CustomAlert';
import Loader from '../Loader/Loader';
import SMSMasterFilterModal from './SMSMasterFilterModal';

const defaultFilterData = {
  userName: "",
  userCode : "",
  smsFrom: "",
  status: [],
};


const SMSMaster = () => {
  const loggedInUserName = sessionStorage.getItem('username');
  const [noData, setNoData] = useState(false);
  const [SMSData, setSMSData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1);

  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  
  const openModalFilter = () => {
    setIsFilterModalOpen(true);
  };

  const closeModalFilter = () => {
    setIsFilterModalOpen(false);
  };

    const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
    fetchSMSMasterData(1, defaultFilterData);
  };
  
  useEffect(() => {
    fetchSMSMasterData(1, filterData);
}, []);

const fetchSMSMasterData = async (pageNo,filters) => {
    try {
        const requestBody = {
            username: loggedInUserName,
            userName: filters.userName,
            userCode: filters.userCode,
            smsFrom: filters.smsFrom,
            // status: filters.status || "",
            status: filters.status?.length > 0 ? filters.status : ""

            // status: ""
        };

        const response = await axiosPostApi(
            `${apiList.SMS_MASTER_DATA}?&pageSize=${pageSize}&pageNo=${pageNo}`,
            requestBody
        );
        
        if (response?.data?.status === true && response?.data?.respCode === "00") {
            setPageDetails(response?.data?.pageDetails);
            const transactions = response?.data?.data;
            const modifiedData = modifyStructure(transactions);
            setSMSData(modifiedData);

            if (modifiedData?.length === 0) {
                setNoData(true);
            } else {
                setNoData(false);
            }
        } else {
            setNoData(true);
            setSMSData([]);
            // if (response?.data?.data !== null || response?.data?.data?.length === 0) {
            //     CustomAlert({
            //         title: "No Data",
            //         text: "No data available for the specified criteria.",
            //         icon: 'info',
            //         confirmButtonText: 'Okay'
            //     });
            // }
        }
    } catch (error) {
        CustomAlert({
            title: "Error",
            text: "An error occurred while fetching the data. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry"
        });
        setSMSData([]);
    } finally {
        setLoading(false);
    }
};

const modifyStructure = (response) => {
    return response?.map((item, index) => ({
        ...item,
        id: index + 1,
    }));
};

  const SMSHeaders = [
    "Status",
    "User Code",
    "User Name",
    "Mobile No",
    "Request Date-Time",
    "SMS Text",
    "SMS From",
    "Send Transaction",
    "Response Description",
    "Response Date-Time",
    "SMS Key",
    "Template ID",
    "Entity ID",
    "Response Transaction ID"
];

const SMSHeaderToKeyMap = {
    "Status": "status",
    "User Code": "userCode",
    "User Name": "username",
    "Mobile No":"mobileNo",
    "Request Date-Time": "otpDate",
    "SMS Text": "sms",
    "SMS From": "smsFrom",
    "Send Transaction": "sendTxnId",
    "Response Description":"smsResponse",
    "Response Date-Time":"responseDate",
    "SMS Key": "smsKey",
    "Template ID": "templateId",
    "Entity ID": "entityId",
    "Response Transaction ID": "responseTxnId",
}

const pageSizeCount = pageDetails === null  ? 0 : pageDetails.pageSize;
const totalRecord = pageDetails === null  ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ?
      <Loader /> :
      <>
      <MasterTable
        headers={SMSHeaders}
        data={SMSData}
        filterFields={['username']}
        entityType="SMS Master"
        headerToKeyMap={SMSHeaderToKeyMap}
        loading={loading}
        pageDetails={pageDetails}
        noData={noData}
        currentPage={currentPage}
        pageSize={pageSizeCount}
        totalRecord={totalRecord}
        handleReset={handleReset}
        setCurrentPage={setCurrentPage}
        fetchNextData={(pageNo) => fetchSMSMasterData(pageNo, filterData)}
        filterData={filterData}
        openModalFilter={openModalFilter}
        fetchData={() => fetchSMSMasterData(1, defaultFilterData)}
      />

        {isFilterModalOpen && (
        <SMSMasterFilterModal
          show={isFilterModalOpen}
          handleClose={closeModalFilter}
          setFilterData={setFilterData}
          filterData={filterData}
          handleReset={handleReset}
          setSMSData={setSMSData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          currentPage={currentPage}
          pageSize={pageSizeCount}
        />
      )}
      </>}</div>
  )
}

export default SMSMaster